import React from "react";
import { cx } from "./utils";

const DataToolbar = ({ children, className = "" }) => (
  <div className={cx("rounded-2xl border border-slate-200 bg-white p-3 shadow-sm", className)}>
    {children}
  </div>
);

export default DataToolbar;
